<template>
  <div class="section-solution-preview-bg">
    <div style="background-color: #09041f">
      <div class="container nav-bar-solutions">
        <div class="left">
          <p class="title">Solutions</p>
        </div>
        <button
          class="view-button all-solutions-show"
          @click="redirectToOurSolutionsPage"
        >
          View All Solutions
        </button>
      </div>
    </div>

    <div class="container form-row" data-aos="fade-up">
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <!-- <a href="#"> -->
          <img
            class="card-img-top"
            :src="this.publicPath + 'assets/img/pngs/aggregator.png'"
            alt="aggregator"
          />
          <!-- </a> -->
        </div>
      </div>
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <!-- <a href="#"> -->
          <img
            class="card-img-top"
            :src="this.publicPath + 'assets/img/pngs/aggregator-branded.png'"
            alt="aggregator branded"
          />
          <!-- </a> -->
        </div>
      </div>
      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <!-- <a href="#"> -->
          <img
            class="card-img-top"
            :src="this.publicPath + 'assets/img/pngs/crm-engine.png'"
            alt="crm engine"
          />
          <!-- </a> -->
        </div>
      </div>

      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <!-- <a href="#"> -->
          <img
            class="card-img-top"
            :src="this.publicPath + 'assets/img/pngs/platform-w.png'"
            alt="platform"
          />
          <!-- </a> -->
        </div>
      </div>

      <div class="col-md-4 col-6 my-3">
        <div class="card">
          <!-- <a href="#"> -->
          <img
            class="card-img-top"
            :src="this.publicPath + 'assets/img/pngs/slot-engine-builder.png'"
            alt="slot engine and builder"
          />
          <!-- </a> -->
        </div>
      </div>
      <div class="col-md-4 col-6 my-3">
        <div class="card" style="padding: 6px 0px">
          <!-- <a href="#"> -->
          <img
            class="card-img-top"
            style="padding: 6px 16px"
            :src="this.publicPath + 'assets/img/pngs/slots.png'"
            alt="slots"
          />
          <!-- </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurSolutions_Page_preview",
  components: {},
  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
    };
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    redirectToOurSolutionsPage() {
      this.$router.push(`/${this.lang}/solutions`);
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 25px !important;
  padding-bottom: 25px !important;
  max-width: 1120px !important;
}

.section-solution-preview-bg {
  /* background-color: #09041f; */
  background-color: rgb(9, 4, 31);
  position: relative;
  background-size: cover;
  padding: 30px 0 50px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background: rgb(9, 4, 31);
}

.col-md-4 {
  flex: 0 0 33.333%;
  max-width: 33.333%;
  padding: 0 15px;
  box-sizing: border-box;
  justify-content: space-around;
  display: flex;
}

@media (max-width: 576px) {
  .col-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .nav-bar-solutions {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .nav-bar-solutions {
    margin-bottom: 10px !important;
  }

  .container {
    padding-top: 0px !important;
  }
}

.card {
  width: 100%;
  border: 2px solid white;
  border-radius: 5px;
  overflow: hidden;
  min-height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(9, 4, 31);
}

.card-img-top {
  max-width: 250px;
  object-fit: contain;
  height: auto;
}

.nav-bar-solutions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-solution-preview-bg > .nav-bar-solutions .left {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  -ms-flex-align: center;
  align-items: center;
}

.left .title {
  font-size: clamp(14px, 8vw, 40px);
  font-weight: 600;
  color: #fff;
  /* color: #09041f; */
  margin: 0;
  letter-spacing: -0.04em;
  line-height: 1.25;
}

.view-button {
  margin: 15px 0px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  /* color: #09041f; */
  padding: 13px 13px;
  border-radius: 25px;
  border: 2px solid rgb(45, 113, 239);
  transition: 0.3s all;
  min-width: 150px;
  max-width: 300px;
}

.view-button:hover {
  color: white !important;
  font-size: 16px;
  background: rgb(45, 113, 239);
  border: 2px solid rgb(45, 113, 239);
  box-shadow: 0px 0px 15px 5px cornflowerblue;
  cursor: pointer;
}
</style>
